<style>
.input-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.remove-detail {
  height: 100%;
  padding: 10px 15px;
  background-color: var(--red);
  box-shadow: 2px 0 10px var(--red);
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<template>
  <div class="card p-3 mb-3">
    <h2>
      <i
        :class="
          'fas ' +
          [
            pPlanData.id === 1
              ? 'fa-vial'
              : pPlanData.id === 2
              ? 'fa-medal'
              : pPlanData.id === 3
              ? 'fa-trophy'
              : pPlanData.id === 4
              ? 'fa-gem'
              : '',
          ] +
          ' mr-2'
        "
      >
      </i>
      Plano {{ pPlanData.nome }}
    </h2>
    <div class="mt-3">
      <label>Característica</label>
      <input
        class="form-control"
        type="text"
        placeholder="Digite a característica do plano"
        v-model="pPlanData.caracteristica"
      />
    </div>
    <div
      class="d-flex flex-row align-items-center flex-shrink-1 flex-grow-0 mt-3"
    >
      <div class="w-100 mr-3">
        <label>Preço</label>
        <input
          name=""
          class="form-control"
          type="number"
          placeholder="Digite o preço do plano"
          v-model="pPlanData.preco"
        />
      </div>
      <div class="w-100">
        <label>Estrelas</label>
        <input
          min="1"
          max="4"
          class="form-control"
          type="number"
          placeholder="Digite o número de estrelas que esse plano terá"
          v-model="pPlanData.estrelas"
        />
      </div>
    </div>
    <div class="mt-3">
      <label>Detalhes</label>
      <div
        class="input-detail mb-2"
        v-for="(detail, index) in pPlanData.detalhes"
        :key="index"
      >
        <input
          class="form-control"
          type="text"
          placeholder="Digite um detalhe desse plano"
          v-model="pPlanData.detalhes[index]"
        />
        <span class="remove-detail" @click="removeDetail(index)">
          <i class="fas fa-times text-white"></i>
        </span>
      </div>
      <span
        class="d-flex flex-row align-items-center mt-3 c-pointer"
        @click="addDetail()"
      >
        <i class="fas fa-plus-circle c-orange fs-32 mr-3"></i>
        Adicionar mais um detalhe
      </span>
    </div>
    <div class="text-right">
      <button class="btn btn-success mt-3" @click="savePlan()" type="button">
        Salvar Plano {{ pPlanData.nome }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    pPlanData: {
      required: true,
    },
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['getNotification']),
  },
  methods: {
    aviso(texto, tipo, tempo = 5000) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: tempo,
        appendToast: true,
      });
    },
    addDetail() {
      this.pPlanData.detalhes.push(null);
    },
    removeDetail(pIndex) {
      this.pPlanData.detalhes.splice(pIndex, 1);
    },
    savePlan() {
      const data = this.pPlanData;

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateProfessionalPlan', data)
        .then(() => {
          this.$store.dispatch('endLoader');
          this.aviso(`${this.getNotification}`, 'success');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.aviso(`${this.getNotification}`, 'error');
        });
    },
  },
};
</script>
